// extracted by mini-css-extract-plugin
export default {"tag":"GiftTag_tag__vhGJi","banner":"GiftTag_banner__8LSDt","bannerIcon":"GiftTag_bannerIcon__5F8Wk"};